export default __webpack_public_path__ + "static/rimfire-home-2x-3b2c306133bd754f3f382a2cf3b3fc13.png";